import { LegacyButton } from '../../atoms/legacy/LegacyButton';

export type RestartSearchCatchupProps = {
  instance: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function RestartSearchCatchup({ instance }: RestartSearchCatchupProps) {
  const handleClick = () => {
    const confirmed = confirm(
      `Cela appelle le WS 'RestartRattrapageRecherche' qui truncate la table répertoriant tous les criteres de recherche ayant été rattrapés, en somme, il sera possible de relancer les rattapages via une tache schédulées de type 'RattrapageIrisRechercheTask'. Les critere de recherches contenant déjà des quartiers seront exclus. Cette tache sera schedulée automatiquement.`,
    );

    if (!confirmed) {
      alert('Action annulée.');
      return;
    }

    fetch(`/HektorBox/restartRattrapageRecherche?instance=${instance}`)
      .then((res) => res.json())
      .then((res) =>
        res?.result === 'OK'
          ? alert('Tache programmée')
          : alert(res?.result || 'Erreur inconnue'),
      )
      .catch((err) => alert(err.toString()));
  };

  return (
    <LegacyButton onClick={handleClick}>
      Relancer la tache de rattrapage des recherches acquéreurs (ville =&gt; Commune)
    </LegacyButton>
  );
}
